import { Network, Shield, GraduationCap, Wifi } from "lucide-react";
import { EXPERTISE } from "@/data/site";

const ICONS = { Network, Shield, GraduationCap, Wifi };

export default function ExpertiseStrip({ heading = true }) {
  return (
    <section
      data-testid="expertise-strip"
      className="relative border-y border-slate-800/80 bg-[#060B15] py-20 sm:py-24"
    >
      <div className="absolute inset-0 bek-grid opacity-25" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {heading && (
          <div className="max-w-2xl mb-12">
            <div className="bek-eyebrow mb-4">Practice Areas</div>
            <h2 className="text-3xl sm:text-4xl text-white font-semibold tracking-tight">
              {EXPERTISE.length} practice areas we go <span className="bek-chrome">deep on.</span>
            </h2>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {EXPERTISE.map((e, i) => {
            const Icon = ICONS[e.icon];
            return (
              <div
                key={e.name}
                data-testid={`expertise-${e.name.toLowerCase()}`}
                className="bg-[#080F1C] border border-slate-800 p-8 sm:p-10 bek-card-hover relative"
              >
                <div className="absolute top-4 right-4 font-mono-tech text-xs text-slate-700">
                  0{i + 1}
                </div>
                <span className="inline-flex w-12 h-12 items-center justify-center border border-slate-300/40 mb-6">
                  <Icon className="w-6 h-6 text-slate-300" />
                </span>
                <h3 className="text-xl text-white font-semibold mb-3">{e.name}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{e.desc}</p>

                {e.platforms && (
                  <div className="mt-6 pt-5 border-t border-slate-800">
                    <div className="text-[10px] font-mono-tech tracking-[0.25em] uppercase text-slate-500 mb-3">
                      Platforms
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {e.platforms.map((p) => (
                        <span
                          key={p}
                          data-testid={`expertise-platform-${p.toLowerCase().replace(/\s+/g, "-")}`}
                          className="px-3 py-1 border border-slate-800 bg-[#050912] text-slate-300 font-mono-tech text-[11px] tracking-widest uppercase"
                        >
                          {p}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
